import { createLogger } from '../shared/logger'

export const CHILI_TRACKING_DEBUG_KEY = 'chilitracking:debug'

const trackingLogger = createLogger('ChiliTracking', CHILI_TRACKING_DEBUG_KEY)

export const logger = trackingLogger
export const getMode = trackingLogger.getMode
